import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef } from 'react';
import useSearchParams from 'hooks/useSearchParams';
import { useOpenCoachAgent } from 'utils/mindset';
function useCoachDeepLink() {
  var _useOpenCoachAgent = useOpenCoachAgent(),
    triggerCoachAgent = _useOpenCoachAgent.triggerCoachAgent,
    isReady = _useOpenCoachAgent.isReady;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    _useSearchParams2$ = _useSearchParams2[0],
    coachSkillName = _useSearchParams2$.skillName,
    coachingContext = _useSearchParams2$.coachingContext,
    setSearchParams = _useSearchParams2[1];
  var hasTriggeredRef = useRef(false);
  useEffect(function () {
    // Wait for isReady - firing before hasAgentOnPage settles could send
    // the user to the wrong place.
    if (hasTriggeredRef.current || !isReady) return;
    if (!coachSkillName && !coachingContext) return;
    hasTriggeredRef.current = true;
    triggerCoachAgent({
      skillName: coachSkillName ? String(coachSkillName) : undefined,
      coachingContext: coachingContext ? String(coachingContext) : ''
    });

    // Strip so reloading/reopening the link doesn't re-fire a duplicate
    // thread. skillId/week-commencing are read elsewhere, so left alone.
    setSearchParams(function (oldParams) {
      return _objectSpread(_objectSpread({}, oldParams), {}, {
        q: undefined,
        skillName: undefined,
        coachingContext: undefined
      });
    });
  }, [isReady, coachSkillName, coachingContext, triggerCoachAgent, setSearchParams]);
}
export default useCoachDeepLink;